<template>
  <div>
      {{ $t("message.pageNotFound") }}
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
